import React from 'react';
import {
  ButtonContainer,
  LineSeparator,
  VerifyEmailDisplay,
  VerifyEmailHeader,
  VerifySuccessDisplay,
} from './VerifyEmailWallStyles';
import Button from '../../atoms/buttons/Button';

interface IVerifyEmailSuccessProps {
  email: string;
  handleCancel: () => void;
  data: any;
}

const VerifyEmailOtpSuccess: React.FC<IVerifyEmailSuccessProps> = ({ email, handleCancel }) => {
  return (
    <div>
      <VerifyEmailHeader style={{ marginTop: 50 }}>{`Success!`}</VerifyEmailHeader>
      <VerifyEmailDisplay>{email}</VerifyEmailDisplay>
      <LineSeparator />
      <VerifySuccessDisplay>{`Your account is now verified!`}</VerifySuccessDisplay>
      <LineSeparator />
      <ButtonContainer>
        <Button
          type="button"
          buttonType="secondaryBlue"
          customStyle={{ padding: '12px 20px', minWidth: 192, marginBottom: 50 }}
          onClick={handleCancel}
        >
          Close
        </Button>
      </ButtonContainer>
    </div>
  );
};

export default VerifyEmailOtpSuccess;
